import { api } from './client';

export interface RankSnapshot {
  id: string;
  rankTrackerId: string;
  capturedAt: string;
  /** Position in search results (1 = top). Null = not found in the scanned top N. */
  position: number | null;
  /** How many results were scanned when this snapshot was captured. */
  totalResults: number | null;
}

export interface RankTracker {
  id: string;
  pinId: string;
  keyword: string;
  cadence: 'hourly' | 'daily' | 'weekly';
  createdAt: string;
  /** Latest snapshot only (0 or 1 items) — included by the list endpoint. */
  snapshots: RankSnapshot[];
}

export function listTrackers(token: string | null): Promise<RankTracker[]> {
  return api.get<RankTracker[]>('/rank-tracker', token);
}

export function createTracker(
  input: { pinId: string; keyword: string; cadence?: RankTracker['cadence'] },
  token: string | null,
): Promise<RankTracker> {
  return api.post<RankTracker>('/rank-tracker', input, token);
}

/** Snapshots newest-first, up to 180. */
export function trackerHistory(id: string, token: string | null): Promise<RankSnapshot[]> {
  return api.get<RankSnapshot[]>(`/rank-tracker/${id}/history`, token);
}

export function deleteTracker(id: string, token: string | null): Promise<void> {
  return api.delete(`/rank-tracker/${id}`, token);
}
